module.exports = __webpack_public_path__ + "static/media/37.c37812dc.png";